import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './ContactButton.scss';
import kakaoTalkIcon from '../../images/icons/kakao-talk.png';

const ContactButton = () => {
  const getLayoutConfig = () => {
    const isMobile = window.innerWidth < 768;

    return {
      buttonSize: isMobile ? 50 : 60,
      margin: isMobile ? 6 : 12
    };
  };
  const [position, setPosition] = useState(() => {
    const { buttonSize, margin } = getLayoutConfig();

    return {
      x: window.innerWidth - buttonSize - margin,
      y: window.innerHeight - buttonSize - margin
    };
  });
  const [isDragging, setIsDragging] = useState(false);
  const dragStartRef = useRef({ mouseX: 0, mouseY: 0, startX: 0, startY: 0 });
  const suppressClickRef = useRef(false);

  useEffect(() => {
    const { buttonSize, margin } = getLayoutConfig();
    const initialX = window.innerWidth - buttonSize - margin;
    const initialY = window.innerHeight - buttonSize - margin;
    setPosition({ x: initialX, y: initialY });
  }, []);

  const handleKakaoClick = () => {
    // 카카오톡 오픈채팅방 링크로 이동
    // window.open('https://open.kakao.com/o/gZTThd5h', '_blank', 'noopener,noreferrer');
    window.open('https://open.kakao.com/o/sEZXWwmi', '_blank', 'noopener,noreferrer');//최대 300개까지 됨
  };

  const handlePointerDown = (event) => {
    event.preventDefault();
    setIsDragging(true);
    dragStartRef.current = {
      mouseX: event.clientX,
      mouseY: event.clientY,
      startX: position.x,
      startY: position.y
    };

    const handlePointerMove = (moveEvent) => {
      const { buttonSize } = getLayoutConfig();
      const deltaX = moveEvent.clientX - dragStartRef.current.mouseX;
      const deltaY = moveEvent.clientY - dragStartRef.current.mouseY;
      const maxX = window.innerWidth - buttonSize;
      const maxY = window.innerHeight - buttonSize;
      const nextX = Math.min(Math.max(0, dragStartRef.current.startX + deltaX), maxX);
      const nextY = Math.min(Math.max(0, dragStartRef.current.startY + deltaY), maxY);
      setPosition({ x: nextX, y: nextY });
    };

    const handlePointerUp = (upEvent) => {
      const totalX = Math.abs(upEvent.clientX - dragStartRef.current.mouseX);
      const totalY = Math.abs(upEvent.clientY - dragStartRef.current.mouseY);
      suppressClickRef.current = totalX > 4 || totalY > 4;
      setIsDragging(false);
      window.removeEventListener('pointermove', handlePointerMove);
      window.removeEventListener('pointerup', handlePointerUp);

      setTimeout(() => {
        suppressClickRef.current = false;
      }, 0);
    };

    window.addEventListener('pointermove', handlePointerMove);
    window.addEventListener('pointerup', handlePointerUp);
  };

  const handleClick = () => {
    if (suppressClickRef.current) return;
    handleKakaoClick();
  };

  return (
    <motion.button
      className="contact-button"
      onClick={handleClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      style={{ left: position.x, top: position.y }}
      onPointerDown={handlePointerDown}
      aria-label="카카오톡 문의"
      data-dragging={isDragging}
    >
      <span className="contact-button__icon">
        <img src={kakaoTalkIcon} alt="카카오톡" />
      </span>
    </motion.button>
  );
};

export default ContactButton;

